import { render, staticRenderFns } from "./LocationUsersViewTable.vue?vue&type=template&id=70d62924&scoped=true&"
import script from "./LocationUsersViewTable.vue?vue&type=script&lang=js&"
export * from "./LocationUsersViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d62924",
  null
  
)

export default component.exports